import {InviteLinkResponse} from "libs/apiClient";
import {formatDateTime, getInviteLinkRoleLabel, getInviteLinkTypeLabel} from "features/discover/functions";
import {Link} from "react-router";

export function InviteLinksTable({
	inviteLinks
}: {
	inviteLinks: InviteLinkResponse[]
}) {
	if (inviteLinks.length === 0) {
		return <div className="empty-sub-table">No links</div>
	}

    return (
		<table className="discover-table">
			<thead>
				<tr>
					<th>ID</th>
					<th>Type</th>
					<th>Role</th>
					<th>Created by</th>
					<th>Created at</th>
					<th>Hash Code</th>
				</tr>
			</thead>
			<tbody>
				{inviteLinks.map((il: InviteLinkResponse, index) => (
					<tr key={`row-${index}`}>
						<td>{il.id}</td>
						<td>
							{getInviteLinkTypeLabel(il.type)}
						</td>
						<td>
							{getInviteLinkRoleLabel(il.role)}
						</td>
						<td>
							{il.createdBy ? <Link to={`/discover/user/${il.createdBy.id}`}>{il.createdBy.name}</Link> : '-'}
						</td>
						<td>
							{formatDateTime(il.createdAt)}
						</td>
						<td>
							{il.hashCode}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	)
}
